import type { AmazonLocale } from '../interfaces';

export const DEFAULT_REGION: AmazonLocale = 'US';

export const API_CONFIG = {
  MAX_RETRIES: 3,
  RETRY_DELAY_MS: 1000,
  RETRY_BACKOFF_MULTIPLIER: 2,

  MAX_ITEMS_PER_PAGE: 50,
  DEFAULT_ITEMS_PER_PAGE: 5,

  MAX_PRODUCTS_TO_SHOW: 5,
  MIN_PRODUCTS_TO_SHOW: 3,
} as const;
